<template>
  <comments :disabled="disabled" class="pt-2 pb-2"></comments>
</template>

<script setup lang="ts">
import Comments from '@/components/comments/v2/Comments.vue'
import { computed } from 'vue'
import { useDocumentAgreement } from '../documentAgreement'

defineOptions({
  name: 'Comments',
})

const { isErm, isAuthor, participants, userId } = useDocumentAgreement()

const disabled = computed<boolean>(() => {
  return (
    !isErm.value &&
    !isAuthor.value &&
    !participants.value?.map(a => a.userId).includes(userId.value)
  )
})
</script>
